import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  Typography,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import styles from "../../../styles.module.css";

import {
  Breadcrumb,
  StyledTableCell,
  StyledTableRow,
} from "../../reusableComponent/Reusables";

import HeaderSection from "../../reusableComponent/HeaderSection";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import Finish_good_inventory from "../../../services/report/Finish_good_inventory";

const FinishedGoodInvReport = () => {
  const [searchKey, setSearchKey] = useState("");
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: 10,
  });

  const [successMessage, setSuccessMessage] = useState(null);
  const [rows, setRows] = useState([]);
  const [allRows, setAllRows] = useState([]);
  const [depots, setDepots] = useState([]);
  const [selectedDepot, setSelectedDepot] = useState("");

  useEffect(() => {
    fetchData();
  }, [controller.page, controller.rowsPerPage, searchKey, selectedDepot]);

  const fetchData = async () => {
    try {
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey,
        depot: selectedDepot,
      };
      const response = await Finish_good_inventory.getFinishGoodInvotryRepotrepotlist(params);
      setAllRows(response || []);
      setRows(response || []);

      const uniqueDepots = [...new Set((response || []).map((item) => item.depot))];
      setDepots(uniqueDepots);
    } catch (error) {
      setSuccessMessage("Error fetching data");
    }
  };

  const handleChangePage = (event, newPage) => {
    setController((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const handleSearch = (e) => {
    setSearchKey(e.target.value);
    setController((prev) => ({ ...prev, page: 0 }));
  };

  const handleDepotChange = (event) => {
    setSelectedDepot(event.target.value);
    setController((prev) => ({ ...prev, page: 0 }));
  };

  const start = controller.page * controller.rowsPerPage;
  const end = start + controller.rowsPerPage;
  const paginatedRows = rows.slice(start, end);
  const paginationInfo = `${start + 1}-${Math.min(end, rows.length)} of ${rows.length}`;

  return (
    <Box className={styles.cts_page} sx={{ padding: "0px !important", margin: "0px !important" }}>
      <Box className={styles.body}>
        <Breadcrumb routeSegments={[{ name: "Finished Good Report" }]} />

        <HeaderSection
          title="FINISHED GOOD REPORT"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={rows}
          fields={[]}
          labels={[]}
          filename="Finished Good Report"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
          showAddButton={false}
        />

        <Box sx={{ mb: 2, ml: 2 }}>
          <FormControl sx={{ minWidth: 200 }}>
            {/* <InputLabel id="depot-select-label">Filter by Depot</InputLabel> */}
            <Select
          
              value={selectedDepot}
              onChange={handleDepotChange}
              // label="Filter by Depot"
              displayEmpty>
              {/* <MenuItem value="">All Depots</MenuItem> */}
              {depots.map((depot, idx) => (
                <MenuItem key={idx} value={depot}>
                  {depot}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Paper sx={{ width: "100%" }}>
          <TableContainer component={Paper} className={styles.list_tbl_container}>
            <Table size="small" stickyHeader>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="left">Cylinder Code</StyledTableCell>
                  <StyledTableCell align="left">Product Name</StyledTableCell>
                  <StyledTableCell align="left">Product Code</StyledTableCell>
                  <StyledTableCell align="right">Quantity</StyledTableCell>
                  <StyledTableCell align="right">UOM</StyledTableCell>
                  <StyledTableCell align="right">Count</StyledTableCell>
                  <StyledTableCell align="left">Depot</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody sx={{ backgroundColor: "#fff" }}>
                {paginatedRows.map((row, index) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell align="left"  className={styles.inspection_cell}>{row.cylinder_code}</StyledTableCell>
                    <StyledTableCell align="left"  className={styles.inspection_cell}>{row.product_name}</StyledTableCell>
                    <StyledTableCell align="left"  className={styles.inspection_cell}>{row.product_code}</StyledTableCell>
                    <StyledTableCell align="right"  className={styles.inspection_cell}>{row.qty}</StyledTableCell>
                    <StyledTableCell align="right"  className={styles.inspection_cell}>{row.uom}</StyledTableCell>
                    <StyledTableCell align="right"  className={styles.inspection_cell}>{row.count}</StyledTableCell>
                    <StyledTableCell align="left"  className={styles.inspection_cell}>{row.depot}</StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            component="div"
            count={rows.length}
            page={controller.page}
            onPageChange={handleChangePage}
            rowsPerPage={controller.rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>

        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== "clickaway") {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};

export default FinishedGoodInvReport;
